import type { Commodity } from '@enmon/commons/lib/shared';
import { commoditiesConfig } from '@/utils/commodities';

/**
 * Sorts commodities by their configured display order.
 * @param a first commodity
 * @param b second commodity
 * @returns -1 if a is before b, 1 if a is after b, 0 if they are equal
 */
export const sortCommodities = (a: Commodity, b: Commodity): number => {
  return commoditiesConfig[a].order - commoditiesConfig[b].order;
};
